<template>
  <div>
    <!-- Resumen de pagos -->
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="card bg-light">
          <div class="card-body">
            <div class="row text-center">
              <div class="col-md-3">
                <div class="border rounded p-2 bg-white">
                  <h5 class="text-primary mb-0">Bs. {{ formatNumber(resumen.monto_total) }}</h5>
                  <small class="text-muted">Monto Total</small>
                </div>
              </div>
              <div class="col-md-3">
                <div class="border rounded p-2 bg-white">
                  <h5 class="text-success mb-0">Bs. {{ formatNumber(resumen.total_pagado) }}</h5>
                  <small class="text-muted">Total Pagado</small>
                </div>
              </div>
              <div class="col-md-3">
                <div class="border rounded p-2 bg-white">
                  <h5 class="text-warning mb-0">Bs. {{ formatNumber(resumen.saldo_pendiente) }}</h5>
                  <small class="text-muted">Saldo Pendiente</small>
                </div>
              </div>
              <!--
              <div class="col-md-3">
                <div class="border rounded p-2 bg-white">
                  <h5 class="text-info mb-0">{{ resumen.porcentaje_pagado }}%</h5>
                  <small class="text-muted">Progreso</small>
                  <div class="progress mt-1" style="height: 5px;">
                    <div class="progress-bar" :style="{ width: resumen.porcentaje_pagado + '%' }"></div>
                  </div>
                </div>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Botón para agregar pago (solo si estado es RECIBIDA) -->
    <div class="row mb-3" v-if="solicitud.estado === 'EN_PAGO' && hasPermission('pago_solicitar')">
      <div class="col-md-12 text-end">
        <BButton variant="primary" @click="openModal()">
          <i class="fa fa-plus me-1"></i> Registrar Pago
        </BButton>
      </div>
    </div>

    <!-- Tabla de pagos -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light">
            <h6 class="mb-0"><i class="fa fa-money-bill me-2"></i>Historial de Pagos</h6>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Comprobante C-319</th>
                    <th>N° Factura</th>
                    <th class="text-end">Monto</th>
                    <th>Fecha Pago</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="pago in pagos" :key="pago.id">
                    <td>{{ pago.comprobante_c319 || '-' }}</td>
                    <td>{{ pago.factura_numero || '-' }}</td>
                    <td class="text-end fw-bold">Bs. {{ formatNumber(pago.monto_pagado) }}</td>
                    <td>{{ formatDate(pago.fecha_pago) }}</td>
                    <td>
                      <BBadge :variant="pago.estado_color || getEstadoVariant(pago.estado)">
                        {{ pago.estado_texto || formatEstado(pago.estado) }}
                      </BBadge>
                    </td>
                    <td>
                      <div class="btn-group">
                        <BButton 
                          v-if="hasPermission('pago_registrar') && pago.estado !== 'PAGADO'"
                          size="sm" 
                          variant="warning" 
                          @click="openModal(pago)"
                          title="Editar"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                        <!--
                        <BButton 
                          v-if="hasPermission('pago_registrar') && pago.estado !== 'PAGADO'"
                          size="sm" 
                          variant="info" 
                          @click="cambiarEstado(pago)"
                          title="Cambiar Estado"
                        >
                          <i class="fa fa-drive"></i>
                        </BButton>
                        -->
                        <BButton 
                          v-if="hasPermission('pago_registrar') && pago.estado === 'SOLICITADO'"
                          size="sm" 
                          variant="danger" 
                          @click="confirmDelete(pago)"
                          title="Eliminar"
                        >
                          <i class="fa fa-trash"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="pagos.length === 0">
                    <td colspan="8" class="text-center text-muted">No hay pagos registrados</td>
                  </tr>
                </tbody>
                <tfoot class="table-group-divider" v-if="pagos.length > 0">
                  <tr class="table-active">
                    <td colspan="2" class="text-end fw-bold">TOTAL:</td>
                    <td class="text-end fw-bold text-success">Bs. {{ formatNumber(resumen.total_pagado) }}</td>
                    <td colspan="5"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PARA REGISTRAR/EDITAR PAGO -->
    <BModal v-model="modalVisible" :title="modalTitle" size="lg" centered hide-footer>
      <form @submit.prevent="savePago">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-2">
              <label class="form-label">Comprobante C-319</label>
              <input v-model="form.comprobante_c319" type="text" class="form-control" placeholder="Ej: C-319-001">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-2">
              <label class="form-label">N° Factura</label>
              <input v-model="form.factura_numero" type="text" class="form-control" placeholder="Ej: 001-1234567">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-2">
              <label class="form-label">Monto Pagado (Bs) *</label>
              <input 
                v-model="form.monto_pagado" 
                type="number" 
                step="0.01" 
                class="form-control" 
                :class="{ 'is-invalid': errors.monto_pagado }"
                required
              >
              <div class="invalid-feedback" v-if="errors.monto_pagado">{{ errors.monto_pagado[0] }}</div>
              <small class="text-muted" v-if="resumen.saldo_pendiente > 0">Saldo pendiente: Bs. {{ formatNumber(resumen.saldo_pendiente) }}</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-2">
              <label class="form-label">Fecha Pago *</label>
              <input v-model="form.fecha_pago" type="date" class="form-control" required>
            </div>
          </div>
          <div class="col-md-12" v-if="form.id">
            <div class="form-group mb-2">
              <label class="form-label">Estado</label>
              <select v-model="form.estado" class="form-select">
                <option value="SOLICITADO">Solicitado</option>
                <option value="APROBADO">Aprobado</option>
                <option value="PAGADO">Pagado</option>
              </select>
            </div>
          </div>
        </div>
        
        <div class="modal-footer mt-3">
          <BButton type="button" variant="secondary" @click="modalVisible = false">Cancelar</BButton>
          <BButton type="submit" variant="primary" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status"></span>
            {{ form.id ? 'Actualizar' : 'Registrar' }}
          </BButton>
        </div>
      </form>
    </BModal>

    <!-- MODAL PARA CAMBIAR ESTADO -->
    <BModal v-model="modalEstadoVisible" title="Cambiar Estado del Pago" size="md" centered hide-footer>
      <form @submit.prevent="confirmarCambioEstado">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-2">
              <label class="form-label">Estado</label>
              <select v-model="nuevoEstado" class="form-select">
                <option value="SOLICITADO">Solicitado</option>
                <option value="APROBADO">Aprobado</option>
                <option value="PAGADO">Pagado</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer mt-3">
          <BButton type="button" variant="secondary" @click="modalEstadoVisible = false">Cancelar</BButton>
          <BButton type="submit" variant="primary" :disabled="loadingEstado">
            Cambiar Estado
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BButton, BBadge, BModal } from 'bootstrap-vue-3';
import { useAuthStore } from '@/stores/authStore';

const props = defineProps({ 
  solicitud: { type: Object, required: true },
  solicitudId: { type: Number, required: true }
});
const emit = defineEmits(['refresh']);

const authStore = useAuthStore();

// Datos
const pagos = ref([]);
const resumen = ref({
  monto_total: 0,
  total_pagado: 0,
  saldo_pendiente: 0,
  porcentaje_pagado: 0,
  cantidad_pagos: 0,
  estado_pagos: { solicitado: 0, aprobado: 0, pagado: 0 }
});

// Estados del modal
const modalVisible = ref(false);
const modalEstadoVisible = ref(false);
const loading = ref(false);
const loadingEstado = ref(false);
const errors = ref({});

// Formulario
const form = ref({
  id: null,
  solicitud_id: props.solicitudId,
  comprobante_c319: '',
  factura_numero: '',
  monto_pagado: '',
  fecha_pago: new Date().toISOString().split('T')[0],
  estado: 'SOLICITADO'
});

// Para cambiar estado
const pagoSeleccionado = ref(null);
const nuevoEstado = ref('SOLICITADO');

const modalTitle = computed(() => form.value.id ? 'Editar Pago' : 'Registrar Pago');

// Permisos
const hasPermission = (permission) => {
  return authStore.hasPermission(permission);
};

// Obtener pagos y resumen
const fetchPagos = async () => {
  try {
    const response = await axios.get(`/pagos/${props.solicitud.id}`);
    pagos.value = response.data.data;
    resumen.value = {
      ...resumen.value,
      total_pagado: response.data.total_pagado || 0
    };
  } catch (error) {
    console.error('Error fetching pagos:', error);
  }
};

const fetchResumen = async () => {
  try {
    const response = await axios.get(`/pagos/resumen/${props.solicitud.id}`);
    if (response.data.success) {
      resumen.value = response.data.data;
    }
  } catch (error) {
    console.error('Error fetching resumen:', error);
  }
};

// Abrir modal para registrar/editar
const openModal = (pago = null) => {
  errors.value = {};
  if (pago) {
    form.value = {
      id: pago.id,
      solicitud_id: pago.solicitud_id,
      comprobante_c319: pago.comprobante_c319 || '',
      factura_numero: pago.factura_numero || '',
      monto_pagado: pago.monto_pagado,
      fecha_pago: pago.fecha_pago,
      estado: pago.estado
    };
  } else {
    form.value = {
      id: null,
      solicitud_id: props.solicitud.id,
      comprobante_c319: '',
      factura_numero: '',
      monto_pagado: '',
      fecha_pago: new Date().toISOString().split('T')[0],
      estado: 'SOLICITADO'
    };
  }
  modalVisible.value = true;
};

// Guardar pago
const savePago = async () => {
  loading.value = true;
  errors.value = {};
  
  try {
    if (form.value.id) {
      await axios.put(`/pagos/actualizar/${form.value.id}`, form.value);
      Swal.fire('Éxito', 'Pago actualizado correctamente', 'success');
    } else {
      await axios.post(`/pagos/guardar`, form.value);
      Swal.fire('Éxito', 'Pago registrado correctamente', 'success');
    }
    modalVisible.value = false;
    await fetchPagos();
    await fetchResumen();
    emit('refresh');
  } catch (error) {
    if (error.response?.status === 422) {
      errors.value = error.response.data.errors;
    } else {
      Swal.fire('Error', error.response?.data?.message || 'Error al guardar', 'error');
    }
  } finally {
    loading.value = false;
  }
};

// Cambiar estado (abrir modal)
const cambiarEstado = (pago) => {
  pagoSeleccionado.value = pago;
  nuevoEstado.value = pago.estado;
  modalEstadoVisible.value = true;
};

// Confirmar cambio de estado
const confirmarCambioEstado = async () => {
  loadingEstado.value = true;
  try {
    await axios.patch(`/pagos/cambiar-estado/${pagoSeleccionado.value.id}`, {
      estado: nuevoEstado.value
    });
    Swal.fire('Éxito', 'Estado actualizado correctamente', 'success');
    modalEstadoVisible.value = false;
    await fetchPagos();
    await fetchResumen();
    emit('refresh');
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al cambiar estado', 'error');
  } finally {
    loadingEstado.value = false;
  }
};

// Confirmar eliminación
const confirmDelete = (pago) => {
  Swal.fire({
    title: '¿Eliminar pago?',
    text: `Esta acción eliminará el pago por Bs. ${formatNumber(pago.monto_pagado)}`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await axios.delete(`/pagos/eliminar/${pago.id}`);
        Swal.fire('Éxito', 'Pago eliminado correctamente', 'success');
        await fetchPagos();
        await fetchResumen();
        emit('refresh');
      } catch (error) {
        Swal.fire('Error', error.response?.data?.message || 'Error al eliminar', 'error');
      }
    }
  });
};

// Formateadores
const formatNumber = (n) => new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2 }).format(n || 0);
const formatDate = (date) => date ? new Date(date).toLocaleDateString('es-BO') : 'N/A';
const formatDateTime = (date) => date ? new Date(date).toLocaleString('es-BO') : 'N/A';
const formatEstado = (e) => {
  const map = { 'SOLICITADO': 'Solicitado', 'APROBADO': 'Aprobado', 'PAGADO': 'Pagado' };
  return map[e] || e;
};
const getEstadoVariant = (e) => {
  const map = { 'SOLICITADO': 'warning', 'APROBADO': 'info', 'PAGADO': 'success' };
  return map[e] || 'secondary';
};

onMounted(() => {
  fetchPagos();
  fetchResumen();
});
</script>

<style scoped>
.progress {
  background-color: #e9ecef;
  border-radius: 5px;
}
.progress-bar {
  background-color: #28a745;
  transition: width 0.3s ease;
}
</style>